<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-2">
            <vs-button
              @click="createContract()"
              class="bg_l_green"
              v-has-permission="permission60"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewContract") }}
            </vs-button>
          </div>
        </div>
        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @close="closeModifyPopup"
          @finish="onfinish"
        ></modify-popup>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ContractName'), sort: 'ContractName' },
                { title: $t('ContarctType'), sort: 'ContarctType' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 30%">
                  {{ row.title }}
                </td>
                <td style="width: 22%">
                  <span v-if="row.salesType == 0">
                    {{ $t("InternalSales") }}
                  </span>
                  <span v-if="row.salesType == 1">
                    {{ $t("WebsiteSales") }}
                  </span>
                  <span v-if="row.salesType == 2">
                    {{ $t("AgentSale") }}
                  </span>
                  <span v-if="row.salesType == 3">
                    {{ $t("CorporateSales") }}
                  </span>
                  <span v-if="row.salesType == 4">
                    {{ $t("DirectSales") }}
                  </span>
                </td>
                <td style="width: 15%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 30%">
                  <router-link
                    :to="{
                      path: '/SaleContracts/Management/' + row.id,
                      query: { breadcrumbName: row.title },
                    }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="mangement-btn"
                      v-has-permission="permission62"
                      >{{ $t("Management") }}</vs-button
                    >
                  </router-link>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteContract(row.id)"
                    class="d-inline"
                    v-has-permission="permission61"
                  ></vs-button>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
import "../../../assets/scss/vuesax-rtl/pages/_sale.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
export default {
  name: "saleManagement_Contract_Index",

  components: {
    ModifyPopup,
    DataGrid,
  },
  data() {
    return {
      permission60: "CreateContract",
      permission61: "DeleteContract",
      permission62: "GetContractById",
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "Sales/api/ContractsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },
  methods: {
    ...mapActions({
      removeContract: "sale/removeContract",
    }),
    //Open Modal In Create Mode
    createContract() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteContract(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeContract(id).then(() => {
            setTimeout(() => {
              this.$refs.grid.renderGrid();
            }, 2000);
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
